import styled from "styled-components";
import {
  ShoppingCartOutlined,
  SearchOutlined,
  FavoriteBorderOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
/////////////////////////////////////////////////////////////////mobile
const Card = styled.div`
  width: 280px;
  height: 420px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  margin: 10px auto;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);
  }

  @media only screen and (max-width: 768px) {
    width: 90%;
    max-width: 320px;
    height: 320px;
  }

  @media only screen and (max-width: 400px) {
    width: 95%;
    height: 300px;
  }
`;
///////////////////////////////////////////////////////////////mobile

const ImageWrapper = styled.div`
  width: 100%;
  height: 65%;
  overflow: hidden;
  position: relative;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.4s ease;

  ${Card}:hover & {
    transform: scale(1.08);
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6));
  opacity: 0;
  transition: opacity 0.3s ease;

  ${Card}:hover & {
    opacity: 1;
  }
`;

const IconRow = styled.div`
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 14px;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${Card}:hover & {
    opacity: 1;
  }
`;

const IconBox = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;

  &:hover {
    background: #fff;
    transform: scale(1.12);
  }
`;

const Info = styled.div`
  padding: 12px 16px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 600;
`;

const Details = styled.p`
  margin: 4px 0 0;
  font-size: 14px;
  color: #555;
`;

const Description = styled.p`
  margin: 6px 0 0;
  font-size: 13px;
  color: #666;
  line-height: 1.3;
`;

const PriceTag = styled.p`
  margin: 8px 0 0;
  font-size: 18px;
  font-weight: 700;
  color: #0a7cff;
`;

const Product = ({ item, mode, fromStore, openInNewTab}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const url =
      mode === "realestate"
        ? `/realestate/item/${item._id}`
        : `/car/${item._id}`;
        
        if (fromStore) {
         sessionStorage.setItem("prevPage", "store");
         sessionStorage.setItem("storeScroll", window.scrollY.toString());
         }
  
    if (openInNewTab) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };
  
  

  return (
    <Card onClick={handleClick}>
      <ImageWrapper>
        <Image
          src={`/uploads/${item.img}`}
          alt={item.type || item.marque}
        />
        <Overlay />
        <IconRow>
          <IconBox>
            <ShoppingCartOutlined />
          </IconBox>
          <IconBox>
            <SearchOutlined />
          </IconBox>
          <IconBox>
            <FavoriteBorderOutlined />
          </IconBox>
        </IconRow>
      </ImageWrapper>

      <Info>
        {mode === "realestate" ? (
          <>
            <Title>
              {item.type} • {item.city}
            </Title>

            <Details>
            Store: {item.storeName} • Mobile: {item.mobile}
            </Details>

            <Description>
              {item.description?.slice(0, 60)}...
            </Description>

            <PriceTag>{item.price} SR</PriceTag>
          </>
        ) : (
          <>
            <Title>
              {item.country} • {item.marque} {item.model}
            </Title>

            <Details>
              {item.year} • {item.odometer} km • {item.location}
            </Details>

            <Description>
              {item.description?.slice(0, 60)}...
            </Description>

            <PriceTag>{item.price} SR</PriceTag>
          </>
        )}
      </Info>
    </Card>
  );
};

export default Product;
